import Route from "@ember/routing/route";

export default class DnsDomainDnssecRoute extends Route {
  model() {
    return this.modelFor("dns.domain");
  }
}
